import { z } from "zod";

export const wishlistTag = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  shareLink: z.string().optional().nullable(),
});

export type WishlistTag = z.infer<typeof wishlistTag>;
